import {
  jb_image_css_default
} from "./chunk.5N6WHN5E.js";
import {
  Spaceable
} from "./chunk.MFPI4EPN.js";
import {
  reset_css_default
} from "./chunk.PBU2AIHD.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  D,
  ke,
  r
} from "./chunk.NBIYIO67.js";
import {
  n
} from "./chunk.QXWAL3TN.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-image/jb-image.ts
var JbImage = class extends Spaceable(r) {
  _getContentSpacingProperties() {
    return { type: "media" };
  }
  render() {
    return ke`
      <div>
        <jb-picture
          .alt=${this.picture.alt}
          .imgData=${this.picture.imgData}
          .lazy=${this.picture.lazy}
        ></jb-picture>
        ${this.caption ? ke`<p class="caption">${this.caption}</p>` : D}
        ${this.text ? ke`<p class="text">${this.text}</p>` : D}
        ${this.credit ? ke`<p class="credit">${this.credit}</p>` : D}
      </div>
    `;
  }
};
JbImage.styles = [reset_css_default, jb_image_css_default];
__decorateClass([
  n()
], JbImage.prototype, "caption", 2);
__decorateClass([
  n()
], JbImage.prototype, "credit", 2);
__decorateClass([
  n({ type: Object })
], JbImage.prototype, "picture", 2);
__decorateClass([
  n()
], JbImage.prototype, "text", 2);
JbImage = __decorateClass([
  customElement("jb-image")
], JbImage);

export {
  JbImage
};
